import { render, staticRenderFns } from "./TransportadorTab.vue?vue&type=template&id=341f12b6"
import script from "./TransportadorTab.vue?vue&type=script&lang=js"
export * from "./TransportadorTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports